import {FieldConfig} from '../dynamic-field/field.config';
import {ValidationError} from './validation-error';

export interface FieldErrorNotifacation {
    config: FieldConfig<any>;
    error: ValidationError;
}


